package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_01_11_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just split into smaller groups to investigate around the town of Well’s Bounty. They return to the inn where they see Slantha reading a periodical. She heads to bed. The heroes go to their rooms and discuss their findings. Caper says she “met a Trans-Camel; he is named Betsy.” Betsy mentioned that Samuel Thardos, Duke of Brij, has a home in the desert, which Flambo elaborates is two days’ travel to the North-West. Bigglesworth found a note in an outhouse at Rachel & Evan’s home which states “Thardos Family Ruin. Riches. 2 days.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette unsuccessfully attempts to scry the cow with her magical spyglass. Caper claims that the cow is named Alexander.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette asks to scry the Shards of Concar. Dirk pulls the box out of his bag of holding. Tuesday, Dirk, and Annette feel the presence of the shards, both those in the bag and those further away. One shard to the North West is close now. The remaining shards not already in the bag all appear to be in the same location as when the heroes first scried them.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During the night, the heroes hear a roar far to the North. Tuesday thinks that it sounds like Sylas’s roar — perhaps it could be the Blue Dragon that Joral Deetry mentioned seeing.")
    }
}
